import { useLoaderData } from "@tanstack/react-router";
import type { SiteContent } from "@/lib/types";

export function useSite(): SiteContent {
  return useLoaderData({ from: "__root__" }) as SiteContent;
}
